import React from 'react';
import { css } from '@emotion/css';
import {
  useHasWohnenPlusLight,
  useLivingBundleEntitlement,
  usePlusRentEntitlement,
} from '../../../customHooks/useGetHasProduct.hook';
import { campaigns } from '../../common/campaigns';
import { useIntl } from '@/i18n';
import { PlusBadge } from '@/components/common/display/plusBadge/PlusBadge';
import { PromotionBanner } from '@/components/content/someBanner/PromotionBanner';

const styles = {
  plusBadgeHeight: css`
    font-size: 24px;
  `,
};

export const LivingPlusBanner = () => {
  const { t } = useIntl();
  const isEntitledPlusRent = usePlusRentEntitlement();
  const isEntitledLivingPlus = useLivingBundleEntitlement();
  const hasWohnenPlusLight = useHasWohnenPlusLight();
  const showPlusBanner = !isEntitledLivingPlus && !hasWohnenPlusLight && isEntitledPlusRent;

  if (!showPlusBanner) return null;

  return (
    <PromotionBanner
      data-testid='living-plus-banner'
      image={
        <div className={`${styles.plusBadgeHeight}`}>
          <PlusBadge variant='living' />
        </div>
      }
      content={t(
        {
          id: 'livingPlusBanner.description',
          defaultMessage: 'Mit WohnenPlus hast du mehr als nur ein neues Zuhause – du hast Sicherheit',
        },
        {
          WohnenPlusLink: <a href={campaigns.UPSELL_BANNER}>{'Wohnen+'}</a>,
        },
      )}
    />
  );
};
